module.exports = __webpack_public_path__ + "img/k21.edbaddde.jpg";